<!--
 * @Author: Latte
 * @Date: 2021-08-16 14:57:15
 * @LAstEditors: Latte
 * @LastEditTime: 2022-02-10 14:50:43
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\diagnosisManagement\teamMgt\request\index.vue
-->

<template>
  <div class="app-container">
    <my-table
      :tableData="requestList"
      :conf="conf"
      :pageOpt="pageOpt"
      v-loading="loading"
    >
      <!-- 状态 -->
      <template v-slot:status="slotData">
        <el-tag
          :type="slotData.data.auditStatus | tagFilter"
        >{{ slotData.data.auditStatus | statusFilter }}</el-tag>
      </template>

      <!-- 操作 -->
      <template v-slot:operation="slotData">
        <el-button type="primary" size="small" @click.stop="goReqDetail(slotData.data)">查看详情</el-button>
      </template>
    </my-table>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  allowReq,
  deleteReq,
  resumeReq,
  getReqDetail,
  getAllReqList,
} from '@/api/system/diagnosisManagement/joinTeamRequest'
import myTable from '@/components/MyTable/index.vue'
import { joinTeamConf } from '@/config/tableConfig/systemMgt/diagnosticMgt/diagnosticJoinTeam'
export default {
  components: {
    myTable,
  },

  provide() {
    this.pageOpt = Vue.observable(this.pageOpt)

    return {
      pageOpt: this.pageOpt
    }
  },

  data() {
    return {
      loading: false, // 加载开关
      conf: joinTeamConf, // 表格配置
      requestList: [], // 入团申请数组
      // 分页配置
      pageOpt: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
    }
  },

  filters: {
    tagFilter(val) {
      if (val === undefined) return
      if (val === 0) {
        return ''
      } else if (val === 1) {
        return 'success'
      } else if (val === 2) {
        return 'danger'
      }
    },

    statusFilter(val) {
      if (val === undefined) return
      if (val === 0) {
        return '待审核'
      } else if (val === 1) {
        return '已通过'
      } else if (val === 2) {
        return '已拒绝'
      }
    },
  },

  methods: {
    goReqDetail(scope) {
      console.log(" ----------------------")
      console.log("goDetail , scope", scope)
      console.log(" ----------------------")
      this.$router.push({
        name: 'diagnosticJoinTeamDetail',
        params: {
          teamUserReqID: scope.teamUserReqID
        }
      })
    },

    /**
     * @description: 获取入团申请列表
     * @param {*}
     * @return {*}
     */
    getReqList() {
      this.loading = true
      const teamID = this.$route.params.teamID

      const params = {
        "keyWord": "",
        "pageIndex": this.pageIndex,
        "pageSize": this.pageSize,
        "sortName": "",
        "sortOrder": "",
        "teamID": teamID,
        "where": "",
      }

      getAllReqList(params).then((res) => {
        this.requestList = res.data.list
        console.log(" -------------------------------------------------")
        console.log("getAllReqList , this.requestList", this.requestList)
        console.log(" -------------------------------------------------")

        this.utils.stopLoading(this)
      })
    }
  },

  created() {
    this.getReqList()
  },
}
</script>

<style lang="scss" scoped>
</style>